import type { AuditAction } from '@naya/shared'

/**
 * Human labels for audit-log action keys. Keyed by the AUDIT_ACTIONS enum
 * from @naya/shared so a new action shows up as a type error here.
 */
const ACTION_LABELS: Record<AuditAction, string> = {
  admin_login: 'Admin signed in',
  admin_login_failed: 'Failed sign-in attempt',
  admin_logout: 'Admin signed out',
  tenant_created: 'Tenant created',
  tenant_activated: 'Tenant activated',
  tenant_suspended: 'Tenant suspended',
  tenant_unsuspended: 'Tenant unsuspended',
  tenant_notes_updated: 'Tenant details updated',
  tenant_plan_tier_changed: 'Plan tier changed',
  tenant_plan_tier_reassigned: 'Plan tier reassignment scheduled',
  tenant_plan_tier_applied: 'Plan tier reassignment applied',
  tenant_logo_updated: 'Tenant logo updated',
  setup_link_regenerated: 'Setup link regenerated',
  owner_password_reset_link_sent: 'Owner password reset link sent',
  owner_profile_updated: 'Owner profile updated',
  branch_created: 'Branch created',
  branch_updated: 'Branch updated',
  branch_archived: 'Branch archived',
  branch_unarchived: 'Branch unarchived',
  staff_created: 'Staff created',
  staff_updated: 'Staff updated',
  staff_password_reset: 'Staff password reset',
  staff_deleted: 'Staff deleted',
  admin_created: 'Admin created',
  admin_deactivated: 'Admin deactivated',
  admin_reactivated: 'Admin reactivated',
  admin_password_changed: 'Admin password changed',
  impersonation_started: 'Impersonation started',
  impersonation_exited: 'Impersonation ended',
  invoice_created: 'Invoice created',
  invoice_marked_paid: 'Invoice marked paid',
  invoice_voided: 'Invoice voided',
  plan_tier_settings_updated: 'Plan tier settings updated',
  impersonation_mutation: 'Change made while impersonating',
  program_created: 'Loyalty program created',
  program_updated: 'Loyalty program updated',
  program_activated: 'Loyalty program activated',
  program_stamp_icon_uploaded: 'Custom stamp icon uploaded',
  program_hero_uploaded: 'Hero photo uploaded',
  program_hero_brightness_updated: 'Hero brightness adjusted',
  program_hero_removed: 'Hero photo removed',
  customer_enrolled_by_store: 'Customer enrolled by store',
  stamp_issued: 'Stamp issued',
  stamp_redeemed: 'Stamp redeemed',
  enrollment_token_minted: 'Enrollment QR generated',
  broadcast_created: 'Broadcast queued',
  broadcast_cancelled: 'Broadcast cancelled',
  broadcast_removed: 'Broadcast removed from passes',
  analytics_refreshed: 'Analytics refreshed',
  membership_updated: 'Membership tier changed',
  membership_renewed: 'Membership renewed',
  membership_checkin: 'Membership check-in',
  ticket_issued: 'Event ticket issued',
  ticket_voided: 'Event ticket voided',
  ticket_checked_in: 'Event ticket checked in',
  card_reset: 'Loyalty card reset',
  redemption: 'Reward redeemed',
  stamp_adjusted: 'Stamp count corrected',
  customer_revoked: 'Customer revoked',
  customer_unrevoked: 'Customer unrevoked',
  customer_data_erased: 'Customer data erased',
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action as AuditAction] ?? action
}
